import React, { useRef } from 'react';
import Slider from 'react-slick';
import Spacing from '../Spacing';
import rightarrow from "../Images/rightarrow.svg"
import leftarrow from "../Images/leftarrow.svg"
import IconBoxStyle10 from '../IconBox/IconBoxStyle10';
import IconBoxVisionMission from '../IconBox/IconBoxVisionMission';

export default function FeatureCarousel({ sectionTitle, data, useVisionMissionDesign }) {
  const sliderRef = useRef(null);

  const next = () => {
    sliderRef.current.slickNext();
  };

  const previous = () => {
    sliderRef.current.slickPrev();
  };

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    swipeToSlide: true,
    autoplay: true,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 1700,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <div className="container">
      <div className="cs_iconbox_carousel_1 cs_gap_20 position-relative">
        <div className="row">
          <div className="col-lg-4">
            <div style={{ marginBottom: '30px' }}>
              <h2 style={{
                fontStyle: 'italic',
                fontSize: '48px',
                fontWeight: '700',
                color: '#6550C9',
                margin: 0
              }}>
                {sectionTitle}
              </h2>
            </div>
            <Spacing md="30" lg="20" xl="20" />
            <div className="cs_slider_navigation cs_style_2">
              <div className="cs_slider_prev cs_center" onClick={previous}>
                <img src={leftarrow} alt="Prev" />
              </div>
              <div className="cs_slider_next cs_center" onClick={next}>
                <img src={rightarrow} alt="Next" />
              </div>
            </div>
            <div className="cs_height_0 cs_height_lg_30" />
          </div>
          <div className="col-lg-8">
            <Slider
              ref={sliderRef}
              {...settings}
              className="cs_slider_activate"
            >
              {data?.map((item, index) => (
                <div key={index} style={{ height: '100%', padding: '0 10px' }}>
                  <div style={{ height: '100%', display: 'flex', minHeight: useVisionMissionDesign ? '320px' : 'auto' }}>
                    {useVisionMissionDesign ? (
                      <IconBoxVisionMission {...item} />
                    ) : (
                      <IconBoxStyle10 {...item} />
                    )}
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </div>
  );
}
